export const EXTERNAL_TRANSFER_ATTRIBUTE = 'NEONNOW_EXTERNAL_TRANSFER_NUMBER';

export const EXTERNAL_TRANSFER_LABEL = 'External Number';
